import NotInformation from '../../../../../../components/NotInformation';
import React from 'react';
import CustomCard from '../../../../../../components/CustomCard';
import { TrashIcon } from '../../../../../../components/buttons/IconButtons';
import ZoneItem from './ZoneItem';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const CustomizedItem = (
    {
        t,
        list,
        onDelete=null,
        title = "custom_access",
        showNoInformation = true,
        showCard = false,
        iconDelete=true
    }
) => {

    const ListAll = ({ list, onDelete }) => {
        return (<>
            {list?.map((item, index) => (
                <div className="mb-2 px-0" id={`id_${item?.zoneId || index}`} key={`key_${item?.zoneId || index}`}>
                    <CustomCard classes="w-100" classCard="card-shades-300-100" classContent="p-10px">

                        <div className="row align-items-center justify-content-between w-100">

                            <div className="col-12 col-md px-0">
                                <ZoneItem
                                    item={item}
                                />
                            </div>

                            {iconDelete && (
                                <div
                                    className="col-auto d-flex align-items-center justify-content-end flex-shrink-0 px-0 cursor-pointer"
                                    onClick={() => onDelete && onDelete(index)}
                                >
                                    <TrashIcon className="icon-color-shades-400 icon-hover-shades-950" width={16} height={16} />
                                </div>
                            )}
                        </div>
                    </CustomCard>
                </div>
            ))}
        </>);
    }

    return (
        <>
            {title !== '' && <p className="fs-16px ibl-font-w-600 font-color-general-950 py-3">{t(title)}</p>}
            {list?.length > 0
                ?
                <>
                    {showCard ?
                        <CustomCard classes={"w-100"} classCard={'card-border-8px'} classContent={'px-12px'}>
                            <ListAll
                                list={list}
                                onDelete={onDelete}
                            />
                        </CustomCard>
                        :
                        <ListAll
                            list={list}
                            onDelete={onDelete}
                        />
                    }
                </>
                :
                <>{showNoInformation && <NotInformation text={t('no_custom_shifts_added_yet')} card={true} className={'h-215px'} />}</>
            }
        </>
    );

}

export default CustomizedItem
